{
  "menu": {
    "dashboard": "Dashboard",
    "presence": "Attendance list",
    "bookings": "Bookings",
    "workplaces": "Workplaces",
    "lunches": "Lunches",
    "transport": "Parking spots",
    "statistics": "Statistics",
    "reports": "Reports",
    "company": "Company",
    "teams": "Teams & Employees",
    "buildings": "Buildings",
    "advanced": "Advanced",
    "timeslots": "Timeslots",
    "timeslot_kinds": "Timeslot kinds",
    "timeslot_groups": "Timeslot groups",
    "settings": "System settings",
    "qrcodes": "Scan QR-codes",
    "meeting_rooms": "Meeting rooms",
    "companies": "Companies & Departments",
    "jobtitles": "Job titles",
    "information_messages": "Message",
    "ero": "Emergency Response Officers",
    "confidant": "Confidants",
    "bookings_validate": "Validate bookings",
    "emails": "Automatic emails",
    "app_messages": "In app messages",
    "credits": "Credis"
  },
  "pages": {
    "dashboard": {
      "titles": {
        "statistics": "Presence for {{name}}",
        "meeting_rooms": "Meeting rooms in {{name}}"
      },
      "building": {
        "show_all_present": "[ Show all present employees ]"
      },
      "meeting_rooms": {
        "title": "{{name}}",
        "title_capacity": "[capacity {{capacity}} people]",
        "show_all_timeslots": "[ Show all timeslots ]",
        "hide_all_timeslots": "[ Show only current timeslots ]",
        "timeslots": {
          "loading": "Loading...",
          "booked": "{{employee_count}} people; booked by {{name}}",
          "available": "Available"
        }
      }
    },
    "bookings": {
      "index": {
        "booking": {
          "title": "Bookings - Workplaces"
        },
        "lunch": {
          "title": "Bookings - Lunches"
        },
        "transport": {
          "title": "Bookings - Parking spots"
        },
        "meeting_room": {
          "title": "Bookings - Meeting rooms"
        }
      },
      "view": {
        "booking": {
          "title": "Bookings - Workplaces - {{name}}"
        },
        "lunch": {
          "title": "Bookings - Lunches - {{name}}"
        },
        "transport": {
          "title": "Bookings - Parking spots - {{name}}"
        },
        "workplaces": {
          "title": "Workplaces - {{name}}"
        },
        "remove": {
          "title": "Are you sure you want to delete this booking?",
          "button": "Remove this booking",
          "reason": "Reason for deletion",
          "description": "Indicate which timeslots you want to delete for this co-worker."
        },
        "meeting_room": {
          "title": "Meeting room - {{name}}"
        },
        "toggle_only_show_not_scanned_in": "Only show not scanned in",
        "search_employee": "Search by co-worker",
        "toggle_only_show_invitations": "Show invitations only",
        "statistic": {
          "booking_count": "Total number of bookings: {{amount}}",
          "employee_count": "Total number of co-workers: {{amount}}"
        },
        "bookings_validate": {
          "approve": {
            "button": "Approve vehicle"
          },
          "disapprove": {
            "button": "Reject vehicle"
          },
          "information": "When booking a parking space with restrictions, it may happen that we cannot find all the information about a vehicle. As a result, we cannot be certain if a car is allowed to park here. Please manually indicate whether these cars are permitted to park here."
        }
      }
    },
    "presence": {
      "index": {
        "title": "Attendance list",
        "input_search": "Search co-worker"
      },
      "building_presence": "{{amount}} of the {{amount2}} employees are present ({{percentage}}%)",
      "building_booking": "{{amount}} bookings today",
      "building_response_employee": "{{amount}} of the {{amount2}} EROs are present ({{percentage}}%)",
      "building_select": "Select the buildings"
    },
    "occupancy": {
      "building_select": "Select building/floor/room",
      "timeslot_kind_select": "Select timeslot kind"
    },
    "qrcodes": {
      "index": {
        "title": "Scan QR-codes",
        "download_pdf_title": "PDF file",
        "download_pdf_description": "After pressing the button, a PDF file will be created based on the selected location above.",
        "download_pdf_button": "Create the PDF file",
        "warning_inactive": "NB! This QR code does not work. It is possible that the building for which this QR code was created is inactive.",
        "warning": "QR code is inactive"
      }
    },
    "settings": {
      "index": {
        "title": "System settings",
        "reload_takes_time": "The application settings where reloaded, it can take up to 5 minutes before other devices will see these applied"
      }
    },
    "statistics": {
      "index": {
        "title": "Statistics",
        "btn_details": "Details"
      }
    },
    "buildings": {
      "buildings": {
        "title": "Buildings",
        "input_search": "Search building"
      },
      "building": {
        "title": "Building - {{name}}",
        "team": {
          "input_search": "Search floor"
        },
        "employee": {
          "input_search": "Search co-worker"
        },
        "input_search": "Search floor"
      },
      "floor": {
        "title": "Floor  - {{name}}",
        "input_search": "Search room"
      },
      "room": {
        "title": "Room  - {{name}}"
      },
      "contact": {
        "input_search": "Search contact person",
        "title": "Contact person"
      },
      "timeslot_exceptions": {
        "title": "Timeslot exceptions",
        "kind": "Exception kind",
        "name": "Reason of exception (only visible in management)",
        "date_start_end": "Date from/till",
        "timeslots": "Timeslots",
        "reduce_by": "Reduce capacity by",
        "comment": "Remark in app (not mandatory)",
        "kinds": {
          "block": "Block",
          "unblock": "Unblock",
          "reduce": "Reduce capacity",
          "increase": "Increase capacity",
          "hidden": "Hidden"
        },
        "increase_by": "Increase capacity by"
      }
    },
    "teams": {
      "teams": {
        "title": "Teams",
        "input_search_team": "Search team",
        "input_search_employee": "Search co-worker",
        "subtitle": "Number of co-workers: {{count}}"
      },
      "team": {
        "title": "Team",
        "input_search": "Search co-worker"
      },
      "employee": {
        "title": "Co-worker",
        "block_admin": {
          "title": "Administrator",
          "description": "By means of the button below it is possible to assign or remove functionality to the co-worker.",
          "button_create": "Make co-worker an administrator",
          "button_delete": "Remove administrator functions",
          "button_rights": "Manage rights",
          "button_save_rights": "Save rights"
        },
        "block_account": {
          "title": "Account",
          "description": "By pressing the button below the account will be deleted and there is no possibility to recover this account.",
          "button_delete": "Remove account"
        }
      }
    },
    "reports": {
      "index": {
        "title": "Reports",
        "btn_download": "Download"
      },
      "download": {
        "title": "Download"
      },
      "schedule": {
        "title": "Automatically"
      }
    },
    "company": {
      "companies": {
        "title": "Companies",
        "subtitle": "Number of departments: {{count}}",
        "input_search_company": "Search company"
      },
      "company": {
        "title": "Company",
        "input_search": "Search for department"
      },
      "department": {
        "title": "Department"
      }
    },
    "jobtitles": {
      "jobtitle": {
        "title": "Job title"
      },
      "jobtitles": {
        "title": "Job titles",
        "input_search": "Search for job title"
      }
    },
    "information_messages": {
      "index": {
        "title": "Message",
        "ubb_explanation": "You can uses BB-code to add simple markup to your message\n\n[header]This is a header[/header]\n[b]This text is bold[/b]\n[i]This text is italic[/i]\n[u]This text is underlined[/u]"
      }
    },
    "employee": {
      "advanced": {
        "title": "Advanced"
      },
      "credits": {
        "button_add_remove": "Manage amounts"
      }
    },
    "timeslots": {
      "title": "Timeslots",
      "timeslotGroups": {
        "title": "Timeslot groups",
        "input_search": "Search timeslot groups"
      },
      "timeslotKinds": {
        "title": "Timeslot kinds",
        "input_search": "Search timeslot kinds"
      }
    },
    "emails": {
      "index": {
        "title": "Automatic emails",
        "input_search": "Search"
      },
      "edit": {
        "title": "Edit"
      }
    },
    "app_messages": {
      "index": {
        "title": "In app messages"
      },
      "edit": {
        "title": "Edit"
      }
    },
    "credits": {
      "title": "Credits",
      "generate_file": "Create the QR-code",
      "generate_text": "Click the button to generate the QR code file, which can be scanned to initiate the payment.\nAfter the payment, a thumbs-up or thumbs-down will appear on the buyer’s screen, indicating whether the payment was successful.\nThe date on which the payment was initiated will also be displayed for verification purposes."
    }
  },
  "constants": {
    "scanin": "Check  in/out",
    "book": "Book a location"
  },
  "generic": {
    "load_error": "Unable to load data. Please try again.",
    "retry": "Try again",
    "view_all_from": "View all from {{name}}",
    "add": "Add",
    "no_results": "No results found",
    "booking": {
      "kind": {
        "booking": "Workplace",
        "lunch": "Lunch",
        "transport": "Transport",
        "meeting_room": "Meeting room"
      },
      "status": {
        "invite_accepted": "Invitation accepted",
        "invite_rejected": "Invitation declined",
        "cancelled": "Cancelled",
        "invited": "Invited",
        "active": "Active"
      }
    },
    "active": {
      "yes": "Active",
      "no": "Inactive"
    },
    "building": {
      "kind": {
        "office": "Office",
        "parkinglot": "Parking lot"
      }
    },
    "timeslot": {
      "kind": {
        "booking": "Workplace",
        "lunch": "Lunch",
        "meeting_room": "Meeting room",
        "transport": "Parking spot"
      },
      "add": "Add timeslot",
      "remove": {
        "title": "Are you sure you want to delete the timeslot?",
        "button": "Yes, I want to remove the timeslot."
      },
      "description_accepted_some": "The following times are accepted: {{timeslots}}"
    },
    "remove": "Remove",
    "drag": "Change order",
    "employee": {
      "kind": {
        "external": "External guest",
        "internal": "Co-worker"
      }
    },
    "scan": {
      "scanned_in_at": {
        "unkown": "Scanned in at: {{time}}",
        "qrcode": "Scanned in with QR-code at: {{time}}",
        "button": "Scanned in with button at: {{time}}",
        "cronjob": "Scanned in automatically at: {{time}}",
        "automatic": "Scanned in automatically at: {{time}}",
        "qrcode_by_employee": "Scanned in with QR-code by employee at: {{time}}"
      },
      "not_scanned_in": "Not scanned in yet"
    },
    "parking_scan": {
      "not_scanned_in": "Not scanned in yet",
      "scanned_in": "Run in on {{time}} with license plate {{identifier}}",
      "scanned_out": "Finished on {{time}} with registration number {{identifier}}"
    },
    "booking_status": {
      "invite_open": "Invitation not (yet) accepted"
    },
    "invited_by": "Invited by: {{name}}",
    "overview": "Overview",
    "from_to": "from {{from}} to {{till}}",
    "occupied": "Occupied",
    "available": "Available",
    "beta": "This part is still in beta and may contain errors",
    "today": "Today",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "created_at": "Created at"
  },
  "form": {
    "titles": {
      "personal": "Personal",
      "privacy": "Privacy",
      "company": "Company",
      "app_rights": "App rights",
      "commute": "Commuting"
    },
    "search": {
      "title": "Search"
    },
    "kind": {
      "title": "Kind"
    },
    "name": {
      "title": "Name",
      "system_name": "Systemname",
      "en-gb": "Name (English)",
      "nl-nl": "Name (Dutch)"
    },
    "save": "Save",
    "saved": "Saved",
    "day": {
      "title": "Day"
    },
    "credit_amount": {
      "title": "Credit amount"
    },
    "timeslot_start": {
      "title": "Timeslot start"
    },
    "timeslot_end": {
      "title": "Time slot end"
    },
    "capacity": {
      "title": "Capacity"
    },
    "show_time": {
      "title": "Show time"
    },
    "show_capacity": {
      "title": "Show capacity during location selection"
    },
    "show_capacity_in_timeslot": {
      "title": "Show capacity in timeslot during booking"
    },
    "instructions_link": {
      "title": "Instructions link"
    },
    "no_limit": "No limit",
    "time_before_start_time": {
      "week": "{{count}} week before start time",
      "week_other": "{{count}} weeks before start time",
      "day": "{{count}} day before start time",
      "day_other": "{{count}} days before start time",
      "hour": "{{count}} hour before start time",
      "hour_other": "{{count}} hours before start time",
      "minute": "{{count}} minute before start time",
      "minute_other": "{{count}} minutes before start time",
      "at": "Beginning of start time"
    },
    "time_after_start_time": {
      "hour": "{{count}} hour after start time (and before end time)",
      "hour_other": "{{count}} hours after start time (and before end time)",
      "minute": "{{count}} minute after start time (and before end time)",
      "minute_other": "{{count}} minutes after start time (and before end time)"
    },
    "can_only_select_one_per_day": {
      "title": "Can only be booked once a day"
    },
    "count": {
      "title": "Amount 'indicator' (10 workplaces)"
    },
    "can_overlap_with_booking": {
      "title": "Can overlap with a workplace booking on the same time"
    },
    "can_book_for_self": {
      "title": "Can be booked by logged in employee"
    },
    "can_book_for_coworkers": {
      "title": "Can be booked for co-workers"
    },
    "can_book_for_external": {
      "title": "Can be booked for external guests"
    },
    "can_only_book_single_timeslot_per_day": {
      "title": "Can only book 1 timeslot per day"
    },
    "can_book_from": {
      "title": "Can be booked from"
    },
    "can_book_until": {
      "title": "Can be booked until"
    },
    "can_cancel_until": {
      "title": "Can be cancelled until"
    },
    "active": {
      "title": "Active"
    },
    "icon": {
      "title": "Icon"
    },
    "sub_icon": {
      "title": "Sub-icon"
    },
    "icon_color": {
      "title": "Icon color"
    },
    "background_color": {
      "title": "Background color"
    },
    "timeslot_group": {
      "title": "Timeslot group",
      "all": "All timeslot groups"
    },
    "preview_timeslots": {
      "title": "Show availability before booking"
    },
    "available_for": {
      "short": "Available for",
      "title": "Available for teams",
      "description": "Select for which teams this item should remain available."
    },
    "available_for_employee": {
      "title": "Available for employees",
      "description": "Select for which employees this item should remain available."
    },
    "response_employee": {
      "title": "Emergency Response Employee"
    },
    "confidant": {
      "title": "Confidant"
    },
    "teams": {
      "title": "Team"
    },
    "companies": {
      "title": "Company"
    },
    "departments": {
      "title": "Department"
    },
    "jobtitles": {
      "title": "Job title"
    },
    "email": {
      "title": "Email address"
    },
    "landline_phonenumber": {
      "title": "Landline phone number"
    },
    "days": {
      "title": "Days"
    },
    "time_start": {
      "title": "Start time"
    },
    "time_end": {
      "title": "Time end"
    },
    "scan_option": {
      "title": "Scan option"
    },
    "building": {
      "title": "Building",
      "choose": "Choose building"
    },
    "floor": {
      "title": "Floor",
      "all": "All floors"
    },
    "room": {
      "title": "Room",
      "all": "All rooms"
    },
    "timeslot_kinds": {
      "title": "Timeslot kinds",
      "all": "All timeslot kinds",
      "hint": "If you select no specific timeslot kinds all timeslots will be available during booking."
    },
    "constants": {
      "scanin": "Scan in/out",
      "book": "Book location"
    },
    "settings": {
      "titles": {
        "basics": "Basics",
        "bookings": "Booking",
        "coworkers": "Co-workers screen",
        "coworkers_search": "Search screen",
        "others": "Other",
        "profile": "Profile",
        "information": "Information page",
        "Information": "Information page",
        "privacy": "Privacy",
        "workday": "Workdays",
        "ero": "ERO",
        "confidant": "Confidants",
        "teams": "Teams",
        "presence": "Presence",
        "commute": "Commuting",
        "credits": "Credits"
      },
      "company_name": {
        "title": "Company name"
      },
      "email_tld": {
        "title": "Email domainname"
      },
      "calendar_max_date": {
        "title": "Bookings can be made up to",
        "options": {
          "week_1": "1 week ahead",
          "week_2": "2 weeks ahead",
          "month_1": "1 month ahead",
          "month_2": "2 months ahead",
          "month_3": "3 months ahead",
          "month_4": "4 months ahead",
          "month_5": "5 months ahead",
          "month_6": "6 months ahead"
        }
      },
      "scan_in_enabled": {
        "title": "Scan-in enabled"
      },
      "booking_enable_parking": {
        "title": "Book parking spots"
      },
      "booking_enable_lunch": {
        "title": "Book lunches"
      },
      "scan_out_enabled": {
        "title": "Scan-out enabled"
      },
      "transport_select_enabled": {
        "title": "Show Transport selection after checkin"
      },
      "enable_coworkers_screen": {
        "title": "Co-workers screen active"
      },
      "coworker_screen_shows": {
        "title": "Co-workers visible during manual adding"
      },
      "enable_coworkers_link_share": {
        "title": "Share bookings with co-workers through a link"
      },
      "enable_coworkers_direct_share": {
        "title": "Share bookings with co-workers through a QR-code"
      },
      "emergency_number": {
        "title": "Emergency number on ERO screen"
      },
      "booking_enable_reason": {
        "title": "Add reason when booking"
      },
      "scan_enable_presence_meter": {
        "title": "Show busyness meter"
      },
      "calendar_min_date": {
        "title": "Review bookings until"
      },
      "scan_enable_time": {
        "title": "Show scan-in time"
      },
      "coworker_calender_only_for_team": {
        "title": "Show bookings only for employees of the same"
      },
      "coworker_favourite_only_for_team": {
        "title": "Favourites can only be added within the same"
      },
      "coworker_phonenumber_only_for_team": {
        "title": "Show phonenumber only for employees of the same"
      },
      "coworker_show_phonenumber": {
        "title": "Show mobile phonenumber in profile"
      },
      "coworker_show_landline_phonenumber": {
        "title": "Show landline phonenumber in profile"
      },
      "coworker_show_emailaddress": {
        "title": "Toon e-mailaddres in profiel"
      },
      "coworker_search_company": {
        "title": "Search/Filter on company"
      },
      "coworker_search_team": {
        "title": "Search/Filter on team"
      },
      "coworker_search_department": {
        "title": "Search/Filter on department"
      },
      "coworker_search_jobtitle": {
        "title": "Search/Filter on jobtitle"
      },
      "profile_enable_photo_editing": {
        "title": "Allow uploading of employee photo"
      },
      "profile_enable_name_editing": {
        "title": "Allow editing of employee name"
      },
      "profile_enable_phonenumber_editing": {
        "title": "Allow editing of employee mobile phonenumber"
      },
      "profile_enable_landline_phonenumber_editing": {
        "title": "Allow editing of employee landline phonenumber"
      },
      "profile_enable_jobtitle_editing": {
        "title": "Allow editing of employee job title"
      },
      "profile_enable_team_editing": {
        "title": "Allow editing of employee team"
      },
      "profile_enable_department_editing": {
        "title": "Allow editing of employee department"
      },
      "booking_enable_parking_license_plate": {
        "title": "Add license plate input"
      },
      "privacy_editing": {
        "title": "Allow privacy editing"
      },
      "privacy_show_phonenumber": {
        "title": "Who can see phonenumbers"
      },
      "privacy_show_calendar": {
        "title": "Who can see co-worker bookings"
      },
      "privacy_show_favourite": {
        "title": "Who can add favourites"
      },
      "privacy_show_landline_phonenumber": {
        "title": "Who can see landline phonenumbers"
      },
      "privacy_visible_for_employees_default": {
        "title": "Visible to co-workers"
      },
      "profile_editing": {
        "title": "Allow profile editing"
      },
      "workday_editing": {
        "title": "Allow workdays editing"
      },
      "coworker_enable_search": {
        "title": "Enable co-worker search page"
      },
      "log_in_qr_code": {
        "title": "Log-in with QR-code (web only)"
      },
      "ero_enable": {
        "title": "ERO enabled"
      },
      "confidant_enable": {
        "title": "Confidant enabled"
      },
      "profile_enable_ero_editing": {
        "title": "Allow editing of ERO"
      },
      "profile_access_card_id_editing": {
        "title": "Allow editing of Access Card Number"
      },
      "enable_teams": {
        "title": "Teams enable"
      },
      "scan_out_type": {
        "title": "Scan-out option"
      },
      "scan_in_type": {
        "title": "Scan-in type"
      },
      "commute_enable": {
        "title": "Track your commute"
      },
      "credits_enabled": {
        "title": "Credit system acitve"
      }
    },
    "description": {
      "title": "Description"
    },
    "aed": {
      "title": "AED available",
      "description": "Select whether an AED is available or not"
    },
    "phonenumber": {
      "title": "Phone number"
    },
    "visible_for_employees": {
      "title": "Visible to co-workers"
    },
    "verified": {
      "title": "Verified"
    },
    "time_select": {
      "minute": "{{number}} minute",
      "minute_other": "{{number}} minutes",
      "week": "{{number}} week",
      "week_other": "{{number}} weeks",
      "month": "{{number}} month",
      "month_other": "{{number}} months",
      "year": "{{number}} year",
      "year_other": "{{number}} years",
      "hour": "{{number}} hour",
      "hour_other": "{{number}} hours",
      "none": "Not",
      "day": "{{number}} day",
      "day_other": "{{number}} days",
      "always": "Always"
    },
    "error": "Saving failed",
    "title": {
      "title": "Title"
    },
    "content": {
      "title": "Content"
    },
    "available_for_employees": {
      "description": "Select for which employees this item should remain available.",
      "title": "Available for employees"
    },
    "external_id": {
      "title": "Employee number"
    },
    "can_scan_presence_qr_code": {
      "title": "Can scan QR code for attendance"
    },
    "can_scan_presence_qr_code_from": {
      "title": "Can scan QR code for attendance how long before start time slot"
    },
    "can_scan_presence_qr_code_until": {
      "title": "Can scan QR code for attendance how long after start time slot"
    },
    "timeslot_kind_available_for": {
      "team": "Teams",
      "employee": "Co-workers",
      "jobtitle": "Job titles"
    },
    "extra_parameters": {
      "title": "Additional parameters"
    },
    "time": {
      "title": "Time"
    },
    "for_date": {
      "title": "For which day"
    },
    "language": {
      "title": "Language"
    },
    "lunch_options": {
      "title": "Lunch options",
      "hint": "Select the lunch options which are available for this building"
    },
    "limitation_car_type": {
      "title": "Vehicle type",
      "motorcycle": "Motorcycle",
      "car": "Car",
      "company_car": "Company car"
    },
    "limitation_car_fuel_type": {
      "title": "Vehicle fuel type",
      "electric": "Electric",
      "hybrid": "Hybrid",
      "petrol": "Petrol",
      "diesel": "Diesel",
      "lpg": "LPG"
    },
    "car_length_max": {
      "title": "Max length vehicle"
    },
    "car_width_max": {
      "title": "Max width vehicle"
    },
    "car_height_max": {
      "title": "Max height vehicle"
    },
    "car_wheelbase_max": {
      "title": "Max wheelbase vehicle"
    },
    "car_weight_max": {
      "title": "Max weight vehicle"
    },
    "type": {
      "title": "Type",
      "booking_noshow": "Not showing up"
    },
    "subject": {
      "title": "Subject"
    },
    "address_postal_code": {
      "title": "Address",
      "description": "The address where the building is located"
    },
    "status": {
      "title": "Status",
      "active": "Active",
      "inactive": "Inactive"
    },
    "price": {
      "title": "Price"
    }
  },
  "statistics": {
    "bookings_created_by_weekday": {
      "title": "App usage",
      "description": "Days on which workplace bookings where placed"
    },
    "bookings_created_by_month": {
      "title": "App usage",
      "description": "Months on which workplace bookings where placed"
    },
    "bookings_created_by_day": {
      "title": "App usage",
      "description": "Days on which workplace bookings where placed"
    },
    "bookings_scheduled_by_weekday": {
      "title": "Workplace occupation",
      "description": "Most popular office weekdays based on workplace bookings"
    },
    "bookings_scheduled_by_month": {
      "title": "Workplace occupation",
      "description": "Most popular office months based on workplace bookings"
    },
    "bookings_scheduled_by_day": {
      "title": "Workplace occupation",
      "description": "Most popular office days based on workplace bookings"
    },
    "general": {
      "day": "Day",
      "bookings": "Bookings",
      "percentage": "Percentage",
      "year": "Year",
      "week": "Week",
      "name": "Name",
      "amount": "Amount",
      "time": "Time"
    }
  },
  "reports": {
    "bookings_on_day": {
      "title": "Workplace bookings per day",
      "description": "Excelsheet with all workplace bookings on the selected date"
    },
    "lunches_on_day": {
      "title": "Lunch bookings per day",
      "description": "Excelsheet with all lunch bookings and selected lunch options (if applicable) on the selected date"
    },
    "parking_on_day": {
      "title": "Parking spot bookings per day",
      "description": "Excelsheet with all parking spot bookings and drive in/out times (if applicable) on the selected date"
    },
    "employee_booking_count": {
      "title": "Workplace booking numbers per employee",
      "description": "Excel sheet with the total number of bookings per employee on the selected date"
    },
    "transports_on_day": {
      "title": "Transport bookings per day",
      "description": "Excelsheet with all transport bookings on the selected date"
    },
    "workdays": {
      "title": "Working days per employee",
      "description": "Excel sheet with all working days of employees at the office or at home on the selected date"
    },
    "occupancy": {
      "title": "Occupancy",
      "description": "Excel sheet with the occupancy per building/floor/room and timeslot kind on the selected date"
    },
    "commutes": {
      "title": "Commutes",
      "description": "Excel sheet with all CO2 emissions from commuting movements"
    },
    "credits": {
      "title": "Credits",
      "description": "Excel sheet containing all credit purchases and usage per person, displayed on separate tabs."
    }
  },
  "languages": {
    "nl-nl": "Dutch",
    "en-gb": "English"
  },
  "form_block": {
    "title_default": "Data",
    "title_timeslot": "Timeslot",
    "title_timeslot_exceptions": "Timeslot exceptions",
    "title_timeslot_other": "Timeslots",
    "title_floor": "Floor",
    "title_floor_other": "Floors",
    "title_room": "Room",
    "title_room_other": "Rooms",
    "title_available_for_teams": "Team access",
    "title_available_for_employees": "Employee access",
    "title_contact_persons": "Contact persons",
    "title_statistic": "Statistic",
    "title_statistic_other": "Statistics",
    "title_image": "Image",
    "title_icon": "Icon",
    "title_advanced": "Advanced",
    "title_exceptions": "Exceptions",
    "title_lunch": "Lunch options",
    "title_limitations": "Limitations"
  },
  "modal": {
    "scan": {
      "title": "Scan co-worker",
      "description": "Do you want to scan the co-worker for today? This is also intended to scan external guests for attendance statistics.",
      "button_confirm": "Scan in"
    },
    "basic": {
      "cancel": "Cancel"
    },
    "status": {
      "title": "Change booking status",
      "description": "The current status of the booking is \"{{current_status}}\". Select what should be the new status of this booking.",
      "button_confirm": "Adjust booking"
    },
    "block_account": {
      "title": "Remove Account",
      "button_confirm": "Remove",
      "description": "After confirmation, the account will be deleted and cannot be recovered."
    },
    "admin_rights": {
      "title": "Admin rights"
    },
    "credit_management": {
      "text": "Edit the number of credits for this type. You can increase or decrease the number of credits.\nNo additional payment is required for an increase.\nNote: Only unused credits can be removed."
    }
  },
  "charts": {
    "chart_checkin_time": {
      "title": "Check-in time",
      "description": "Most check-ins are made during these times"
    },
    "chart_book_time": {
      "title": "Book time",
      "description": "Most bookings are made during these times"
    },
    "chart_employee_bookings_week": {
      "title": "Bookings per week",
      "description": "Amount of employees who come to the office several days a week"
    },
    "chart_bookings_created_by_weekday": {
      "title": "Book days",
      "description": "The days when most bookings are made"
    },
    "chart_bookings_scheduled_by_weekday": {
      "title": "Booked days",
      "description": "The days for which most bookings are made"
    },
    "tabs": {
      "office": "Office visit",
      "usage": "App usage"
    },
    "chart_total_bookings_week": {
      "title": "Total number of bookings per week",
      "description": "All timeslot bookings counted together separated by type"
    },
    "chart_bookings_present": {
      "title": "Total number of bookings + attendance per year",
      "description": "The numbers are grouped per employee per year"
    },
    "chart_bookings_present_week": {
      "title": "Total number of bookings + attendance per week",
      "description": "The numbers are grouped per employee per week"
    },
    "chart_bookings_present_month": {
      "title": "Total number of bookings + attendance per month",
      "description": "The numbers are grouped per employee per month"
    },
    "chart_bookings_present_day": {
      "title": "Total number of bookings + attendance per day",
      "description": "The numbers are grouped per employee per day"
    },
    "chart_checkin_time_grow": {
      "title": "Check-in time",
      "description": "Most check-ins are made during these times"
    }
  },
  "user_rights": {
    "dashboard": "Dashboard",
    "bookings": "Bookings",
    "bookings_accept_status": "Accept bookings for invitations",
    "bookings_cancel": "Cancellation of booking",
    "bookings_lunches": "Lunch",
    "bookings_meeting_rooms": "Meeting rooms",
    "bookings_parking_spots": "Parking spots",
    "bookings_scan_in": "Scan in",
    "bookings_workplaces": "Workplaces",
    "buildings": "Buildings",
    "companies": "Companies",
    "company": "Company",
    "contact_persons": "Contactpersons",
    "departments": "Departments",
    "employees": "Employees",
    "floors": "Floors",
    "information_messages": "Messages",
    "jobtitles": "Job titles",
    "presence": "Presence",
    "qrcodes": "Scan-in QR-codes",
    "reports": "Reports",
    "rooms": "Rooms",
    "settings": "System settings",
    "statistics": "Statistics",
    "teams": "Teams",
    "teams_employees": "Right for teams/employees",
    "timeslots": "Timeslots"
  },
  "ui": {
    "users": "Users",
    "read": "Read",
    "write": "Write",
    "choose": "Choose an option",
    "teams": "Teams",
    "company": "Company"
  }
}
